const COUNTRY_NAME_KEYS = {
    "ОАЭ": "shell.country.names.ae",
    "UAE": "shell.country.names.ae",
    "United Arab Emirates": "shell.country.names.ae",
    "Казахстан": "shell.country.names.kz",
    "Kazakhstan": "shell.country.names.kz",
    "Кыргызстан": "shell.country.names.kg",
    "Kyrgyzstan": "shell.country.names.kg",
    "Россия": "shell.country.names.ru",
    "Russia": "shell.country.names.ru",
};

export const translateCountryName = (name, t) => {
    const key = COUNTRY_NAME_KEYS[name];
    return key ? t(key) : name;
};
